import IPlanFirm from './IPlanFirm';
import Api from '../../shared/Api';

class PlanFirmsApi {
    static list(): any {
        return new Promise<any>(
            (resolve: (response: IPlanFirm[]) => void, reject: (error: string) => void) => {
                new Api()
                    .get('/views/planfirms')
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static create(name: string): Promise<IPlanFirm> {
        return new Promise<any>(
            (resolve: (result: IPlanFirm) => void, reject: (errors: string[]) => void) => {
                new Api()
                    .post('/views/planfirms', { name: name })
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static edit(id: number) {
        return new Promise<any>(
            (resolve: (result: IPlanFirm) => void, reject: (error: any) => void) => {
                new Api()
                    .get(`/views/planfirms/${id}/edit`)
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static update(planFirm: IPlanFirm) {
        return new Promise<any>(
            (resolve: (result: IPlanFirm) => void, reject: (error: any) => void) => {
                new Api()
                    .put(`/views/planfirms/${planFirm.id}`, {
                        name: planFirm.name
                    })
                    .then(resolve)
                    .catch((error: any) => {
                        reject(error);
                    });
            }
        );
    }

    static delete(id: number) {
        return new Promise<any>((resolve: (result: any) => void, reject: (error: any) => void) => {
            new Api()
                .delete(`/views/planfirms/${id}`)
                .then(resolve)
                .catch((error: any) => {
                    reject(error);
                });
        });
    }
}

export default PlanFirmsApi;
